import {BaseService} from "./BaseService";
import {Plugin} from '../entities/Plugin'
import { StateService } from "@uirouter/angularjs";

export class PluginService extends BaseService<Plugin>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Plugin);
    }
    protected getBaseUrl():string{
        return "plugin";
    }
}
